import styled from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
import { Button as UIButton } from '../../../../../../../Button/styled';
export const Button = styled(UIButton).withConfig(testableStyledComponentConfig) `
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    z-index: 1;
`;
//# sourceMappingURL=index.js.map